import { KTSVG, toAbsoluteUrl } from 'src/_metronic/helpers';

type ProductCardType = {
  mobileDevice: boolean;
};

export default function ProductCard(props: ProductCardType) {
  const { mobileDevice } = props;
  return (
    <div className={`d-flex   w-100 ${mobileDevice ? 'flex-no-wrap overflow-hidden justify-content-start gap-2' : 'flex-wrap justify-content-center gap-6'}`}>
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="d-flex flex-column gap-2 border border-secondary">
          <div className="d-flex align-items-center justify-content-center bg-light" style={{ width: mobileDevice ? '150px' : '226px', height: mobileDevice ? '218px' : '300px' }}>
            <span className="text-muted fs-4 fw-bold">
              <img src={toAbsoluteUrl(`/media/showcasepage-images/${index + 1}.png`)} alt="img" width={mobileDevice ? 200 : ''} height={mobileDevice ? 218 : ''} />
            </span>
          </div>
          <div className="d-flex flex-column gap-1 px-4">
            <div className="d-flex fw-bold fs-5 gap-1">
              <strong>Xmark</strong> Ürün Adı
            </div>
            <div className="d-flex">
              <KTSVG path="/media/icons/duotone/General/Star.svg" className="svg-icon svg-icon-1xt svg-icon-warning" />
              <KTSVG path="/media/icons/duotone/General/Star.svg" className="svg-icon svg-icon-1xt svg-icon-warning" />
              <KTSVG path="/media/icons/duotone/General/Star.svg" className="svg-icon svg-icon-1xt svg-icon-warning" />
              <KTSVG path="/media/icons/duotone/General/Star.svg" className="svg-icon svg-icon-1xt svg-icon-warning" />
              <KTSVG path="/media/icons/duotone/General/Star.svg" className="svg-icon svg-icon-1xt " />
            </div>
            <div className="d-flex fw-bold fs-3 mt-7">00,000,00 TL</div>
            <div className="bg-primary w-full d-flex align-items-center justify-content-center h-30px mb-5 mt-5 text-white fw-bold rounded-sm">Sepete Ekle</div>
          </div>
        </div>
      ))}
    </div>
  );
}
